import type { SettingsPage } from ".";
import { getEntries } from "..";


export function savePage(page: SettingsPage) {
    if (page.template?.save) {
        page.template.save();
        return;
    }

    const settings = getEntries(page.settings.value);
    const values = settings.map(([id, setting]) => [id, (setting as any).value] as const);

    localStorage.setItem(`settings.${page.id}`, JSON.stringify(values));
}

export function loadPage(page: SettingsPage) {
    if (page.template?.load) {
        page.template.load();
        return;
    }

    const values = JSON.parse(localStorage.getItem(`settings.${page.id}`) ?? "[]") as [string, any][] ?? [];
    const settings = page.settings.value;

    values.forEach(([id, value]) => {
        const setting = settings[id];
        if (!setting) return;
        if (value === undefined) return;
        if (setting.type === "action") return;

        setting.value = value;
    });

    page.settings.set(settings);
}
